import React, { useState } from "react";

/**
 * A logo <img> that degrades to the brand name if the file is missing or fails
 * to load, instead of leaving the browser's broken-image icon on the page.
 *
 * The proof strips render logos as direct children of a flex row, so the
 * `parentElement.innerHTML` onError trick used by the per-logo cards elsewhere
 * would wipe out the whole row. Swapping via state keeps the failure local.
 */
export const LogoImage = ({ src, alt, className, fallbackClassName }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return <span className={fallbackClassName}>{alt}</span>;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

export default LogoImage;
